import { AppProps } from 'next/app';
import React from 'react';
import '@app/styles/global.css';
import ClockContextProvider from '@app/contexts/Clock';
import { ClientAreaProvider } from '@app/contexts/ClientArea';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <ClockContextProvider>
        <ClientAreaProvider>
          <Component {...pageProps} />
        </ClientAreaProvider>
      </ClockContextProvider>
    </>
  );
}

export default MyApp;
